import React from 'react';
import { useTranslation } from 'react-i18next';
import { convertInstallWindowToReadableString, replaceURLWithHTMLLinks } from '../../common/common';
import { useCartData, useScheduleDate, useVendor } from '../../hooks/order';
import { VENDORS } from '../../util/util';

const InstalltionInfo = (props) => {
  const { t } = useTranslation();
  const { isWhiAdded, mrcPosIntCharge, chargeMrcPosIpbb, isSelfInstall } = useCartData();
  const { oneTimeCharge, internetPlan } = props;
  const { scheduleDateTime } = useScheduleDate();
  const { vendor } = useVendor();

  const dateTime = convertInstallWindowToReadableString(scheduleDateTime);
  const [reqInstallDate = '', reqInstallTime = ''] = dateTime ? dateTime.split('between') : [];
  const isVendorVerizon = vendor?.split(' ')[0]?.toLowerCase() === 'verizon';
  const activationArr = (internetPlan?.installActivatePoints || '')
    .split('.  ')
    .map(term => term?.trim()?.replace(/\.*$/, ''))
    .filter(Boolean);

  return (
    <>
      <div className="cart-info-panel common-pannel result-fixed-m">
        <h3>{isWhiAdded || isSelfInstall ? t('installationInfo.activationInfo') : t('installationInfo.installationInfo')}</h3>
        <ul>
          {isSelfInstall ?
            // Copy is quoted from SPF2-3237 ("Pay First Month After Activation + CSI"), which
            // supersedes the agent-tool wording this was first ported from - that promised
            // delivery in 3-5 business days rather than the 2 to 3 days stated there. SPF2-3237
            // is still open and will eventually serve this text through the dynamic terms feed,
            // at which point these two strings should give way to it.
            <>
              <li>{t('installationInfo.selfInstallKit')}</li>
              <li>{t('installationInfo.selfInstallFirstMonth')}</li>
            </>
            : isWhiAdded ?
              <>
                {activationArr.map((term, index) => (
                  <li
                    key={index}
                    dangerouslySetInnerHTML={{
                      __html: replaceURLWithHTMLLinks(term + '.'),
                    }}
                  />
                ))}
              </>
              :
              <>
                <li>{t('installationInfo.professionalInstall')} {t('installationInfo.providedBy')} {vendor ? vendor : t('installationInfo.localPhone')}{mrcPosIntCharge > 0 && chargeMrcPosIpbb && internetPlan?.servCode === 'ipbb' ? '.' : <span> {t('installationInfo.withCharge')} {oneTimeCharge} {t('installationInfo.chargedToday')}</span>}</li>
                {
                  scheduleDateTime ?
                    <li>
                      <div className="list-ct">
                        {t('installationInfo.installDateBefore')}&nbsp;
                        {reqInstallDate} {t('installationInfo.installDateBetween')} {reqInstallTime}.
                      </div>
                    </li>
                    :
                    (!isVendorVerizon && <>
                      <li>
                        <div className="list-ct">{t('installationInfo.lookForText')} {t('installationInfo.confirmingInstall')} {t('installationInfo.appointmentDetails')} {t('installationInfo.withinTwoDays')}</div>
                      </li>
                      <li>
                        <div className="list-ct">{t('installationInfo.serviceShouldBe')} {VENDORS.includes(vendor) ? t('installationInfo.installedDays') : t('installationInfo.installedWeek')}</div>
                      </li>
                    </>)
                }
                {isVendorVerizon && <li>{t('installationInfo.cancelRouter')}</li>}
                <li>
                  {t('installationInfo.firstMonthCharge')}
                </li>
              </>
          }
        </ul>
      </div>
    </>
  )
}
export default InstalltionInfo;
